module.exports = __webpack_public_path__ + "img/bio.f1dbe2a6.jpg";